import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import mk from '../../resources/lang/mk.json'
import en from '../../resources/lang/en.json'
import { Layout } from '@/components'

const el = document.getElementById('app')
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'CReaM'

/**
 * Initial page data
 */
const initialPageData = JSON.parse(el.dataset.page)

window.initialPageData = initialPageData

/**
 * ie8n init
 */
const storedLocale = window.localStorage.getItem('cream_locale')
const initialLocale = ['mk', 'en'].includes(storedLocale) ? storedLocale : initialPageData.props.app.locale

i18n.use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // resources: initialPageData.props.translations,
    resources: {
      ...mk,
      ...en
    },
    lng: initialLocale,
    fallbackLng: 'en',
    returnObjects: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    debug: false
  })

createInertiaApp({
  progress: {
    // The delay after which the progress bar will appear, in milliseconds...
    delay: 10,

    // The color of the progress bar...
    color: 'var(--tw-color-primary)',

    // Whether to include the default NProgress styles...
    includeCSS: true,

    // Whether the NProgress spinner will be shown...
    showSpinner: true
  },
  title: (title) => title ? `${title} - ${appName}` : `${appName}`,
  resolve: name => {
    const pages = import.meta.glob('./domain/**/*.jsx', { eager: false })
    return pages[`./domain/${name}.jsx`]()
      .then(resPage => {
        // eslint-disable-next-line react/no-children-prop
        resPage.default.layout = resPage.default.layout || (page => <Layout children={page} />)

        return resPage
      })
  },
  setup ({ el, App, props }) {
    createRoot(el).render(
      <App {...props} />
    )
  }
})
